export default "__VITE_ASSET__CjQZLO6Q__"